module.exports = __webpack_public_path__ + "static/media/truckSymbololgy.b24721ce.svg";